import { render, staticRenderFns } from "./cartridge-model.vue?vue&type=template&id=9cbc4844&"
import script from "./cartridge-model.vue?vue&type=script&lang=js&"
export * from "./cartridge-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cbc4844')) {
      api.createRecord('9cbc4844', component.options)
    } else {
      api.reload('9cbc4844', component.options)
    }
    module.hot.accept("./cartridge-model.vue?vue&type=template&id=9cbc4844&", function () {
      api.rerender('9cbc4844', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/device-manage/cartridge-model/cartridge-model.vue"
export default component.exports